:host {
  display: block;
}
ion-menu {
  --width: 340px;
}